import { useEventRegistration } from "features/events/useEventRegistration";
import { useEventRegistrationContentCheck } from "features/events/useEventRegistrationContentCheck";
import MenuHeader from "features/menu/blocks/MenuHeader";
import React from "react";
import { useParams } from "react-router-dom";
import ContentUnavailable from "ui/ContentUnavailable";
import LoadingPlaceholder from "ui/LoadingPlaceholder";

import "./EventRegistrationPage.css";

const EventRegistrationPage: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();
  const event = useEventRegistration(eventId);
  const contentCheck = useEventRegistrationContentCheck(event?.id);

  const renderContent = () => {
    if (!event || !contentCheck) return <LoadingPlaceholder />;
    if (!contentCheck.ok) return <ContentUnavailable />;

    return (
      <iframe
        key={event.id}
        className="event-registration-page__iframe"
        src={event.registrationLink}
        title={event.title}
      />
    );
  };

  return (
    <div className="event-registration-page">
      <MenuHeader menuSlug={event?.pageConfig?.menuSlug ?? undefined} />
      {renderContent()}
    </div>
  );
};

export default EventRegistrationPage;
